import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';
import theme from '../../theme';
import Theme, { ThemeType } from '../../theme';
import { mappedPalDescriptions } from '../../utils/palDescriptions';
import { defaultScale } from '../../utils/scaling';
import { WeightTargetHeader } from './weight-target-header';
export const WeightTargetPalComponent = translate(['weightTarget'], {
  wait: true,
})(({ t, goToPreviousStep, setPalValue, PALValue }) => {
  return (
    <View style={styles.conainer}>
      <WeightTargetHeader
        title={t('pal')}
        subTitle={t('palCalc')}
        goToPreviousStep={goToPreviousStep}
      />
      {mappedPalDescriptions.map((pal) => {
        return (
          <SelectionContainer
            title={pal.title}
            style={styles.bookingSelectionStyle}
            subTitle={pal.description}
            isSelected={pal.value === PALValue}
            theme={ThemeType.light}
            onPress={() => {
              setPalValue(pal.value);
            }}
            height={defaultScale(100)}
            width={'100%'}
            titleStyle={styles.bookingSelectionTitle}
            subTitleStyle={styles.bookingSelectionSubtitle}
            overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
          />
        );
      })}
    </View>
  );
});

const styles = StyleSheet.create({
  conainer: {
    flex: 1,
  },
  bookingSelectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
  bookingSelectionStyle: {
    paddingHorizontal: defaultScale(33),
    marginBottom: defaultScale(10),
  },
  bookingSelectionSubtitle: {
    fontSize: theme.textStyle.bodyCopyReg.fontSize,
    textAlign: 'center',
    marginTop: defaultScale(-8),
    fontFamily: theme.textStyle.bodyCopyReg.fontFamily,
  },
});
